<template>
  <div class="date-filter">
    <filter-card-wrapper
      :title="title"
      :expanded="expanded"
    >
      <div slot="body">
        <date-input
          id="from-date-filter"
          ref="from-date-filter"
          v-model="fromDateLocal"
          name="from-date-filter"
          type="from-date"
          label="From Date"
          placeholder="Choose from Date"
          format="DD-MMM-YYYY"
          :value="fromDateComputed"
          :first-day-of-week="1"
          :clearable="true"
          :error-message="fromDateError"
          @input="onDateChange($event, 'fromDate', title)"
        />
        <date-input
          id="to-date-filter"
          ref="to-date-filter"
          v-model="toDateLocal"
          name="to-date-filter"
          type="date"
          label="To Date"
          placeholder="Choose To Date"
          format="DD-MMM-YYYY"
          :value="toDateComputed"
          :first-day-of-week="1"
          :clearable="true"
          :error-message="toDateError"
          :disabled="!fromDateLocal && !toDateLocal"
          @input="onDateChange($event, 'toDate', title)"
        />
        <Button
          label="Today"
          appearance="tertiary"
          class="date-filter__button"
          @onClick="onPresetDateChange('Today', title)"
        />
        <Button
          label="Last 7 days"
          appearance="tertiary"
          class="date-filter__button"
          @onClick="onPresetDateChange('Last 7 Days', title)"
        />
        <Button
          label="This month"
          appearance="tertiary"
          class="date-filter__button no-margin"
          @onClick="onPresetDateChange('This Month', title)"
        />
      </div>
    </filter-card-wrapper>
  </div>
</template>

<script>
// External Libraries
import { subMonths, subDays } from "date-fns";

// Common Component
import { DateInput, Button } from "../../components";
// Filter dependent component
import FilterCardWrapper from "./FilterCardWrapper";

export default {
  name: "DateFilters",
  components: {
    FilterCardWrapper,
    DateInput,
    Button,
  },
  props: {
    /**
     * @description
     * When expaneded flag is true, filter content will be shown
    */
    expanded: { type: Boolean, default: false },
    /**
     * @description
     * Name of the filter
    */
    title: { type: String, required: true },
    /**
     * @description
     * fitelData holds complete Object of this filter and it will be returned along with datefilter on change callback
    */
    fieldData: { type: Object, required: true },
    /**
     * @description
     * From Date timestamp
    */
    fromDate: { type: String, default: null },
    /**
     * @description
     * To Date timestamp
    */
    toDate: { type: String, default: null },
  },
  data () {
    return {
      fromDateError: "",
      toDateError: "",
      fromDateLocal: this.fromDate || null,
      toDateLocal: this.toDate || null,
    };
  },
  computed: {
    /**
     * @description
     * If From Date exist then new Date instance will be created
     * @returns {date} - computed From Date
    */
    fromDateComputed () {
      const fromDate = this.fromDate ? new Date(this.fromDate) : null;
      return fromDate;
    },
    /**
     * @description
     * If To Date exist then new Date instance will be created
     * @returns {date} - computed To Date
    */
    toDateComputed () {
      return this.toDate ? new Date(this.toDate) : null;
    },
  },
  methods: {
    /**
     * @description
     * Sets the date for FromDate and ToDate
     * Calls onDateSelect listener method defined on the parent(FilterBar) component,
     * Calls setFilterModified method defined on the parent(FilterBar) component,
     * @param {date} selectedDate - Selected date
     * @param {string} dateType - Range Type of the date
     * @param {selectedKey} - Name of the filter card
    */
    onDateChange (selectedDate, dateType, selectedKey) {
      if (dateType === "fromDate") {
        this.fromDateLocal = selectedDate;
        this.toDateLocal = null;
      } else if (dateType === "toDate") {
        this.toDateLocal = selectedDate;
      }

      this.$parent.$listeners.onDateSelect(
        selectedDate,
        dateType,
        selectedKey,
        this.fieldData
      );
      this.$parent.setFilterModified(true);
    },
    /**
     * @description
     * Sets the FromDate and ToDate based on selected preset
     * Calls onDateSelect listener method defined on the parent(FilterBar) component,
     * Calls setFilterModified method defined on the parent(FilterBar) component,
     * @param {string} dateText - Selected prest 
     * @param {string} dateType - Range Type of the date
     * @param {selectedKey} - Name of the filter card
    */
    onPresetDateChange (dateText, selectedKey) {
      let selectedDate = null;
      if (dateText === "Today") {
        selectedDate = [new Date(), null];
      } else if (dateText === "Last 7 Days") {
        selectedDate = [subDays(new Date(), 7), new Date()];
      } else if (dateText === "This Month") {
        selectedDate = [subMonths(new Date(), 1), new Date()];
      }

      this.fromDateLocal = selectedDate[0];
      this.toDateLocal = selectedDate[1];

      this.$parent.$listeners.onDateSelect(
        selectedDate,
        "custom",
        selectedKey,
        this.fieldData
      );
      this.$parent.setFilterModified(true);
    },
  },
};
</script>

<style lang="scss">
.date-filter {
  display: flex;
  & .filter-card-wrapper__body {
    margin-top: 16px;
  }
  & .filter-card-wrapper__body .form-group {
    margin-bottom: 16px;
  }
  & .date-filter__button {
    margin-bottom: 16px;
    & a{
      justify-content: center;
      display: flex;
      flex: 1;
    }
    &.no-margin {
      margin: 0;
    }
  }
}
</style>
